const topbar = {
    docs: 'الوثائق',
    help: 'المساعدة',
};
export default Object.freeze(topbar);
